// extracted by mini-css-extract-plugin
export var columnList = "_h0-0";